import {
  ADD_PREDICTIVE_ROUTING_CONFIG,
  REPLACE_PREDICTIVE_ROUTING_CONFIG,
  SET_PREDICTIVE_ROUTING,
  SET_PREDICTIVE_ROUTING_CONFIG_REFERENCES
} from './mutationTypes';

import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';


export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_PREDICTIVE_ROUTING](state, predictiveRouting) {
    const filteredPredictiveRouting = predictiveRouting.filter(item => {
      return item.id.substr(0, 2) === 'RP' && item.id.substr(-4) !== 'LINK';
    });
    state.predictiveRouting = filteredPredictiveRouting;
  },
  [ADD_PREDICTIVE_ROUTING_CONFIG](state, config) {
    state.predictiveRouting = [config, ...state.predictiveRouting];
  },
  [REPLACE_PREDICTIVE_ROUTING_CONFIG](state, config) {
    const index = state.predictiveRouting.findIndex(pr => pr.id === config.id);
    if (index >= 0) {
      state.predictiveRouting.splice(index, 1, config);
    }
  },
  [SET_PREDICTIVE_ROUTING_CONFIG_REFERENCES](state, references) {
    state.references = references;
  },
};